/**
 * Editorial section-number badge — magazine-style "03 / 12" indicator.
 * Positions absolutely in the top-right of a section by default.
 */
export const SectionNumber = ({ n, total = 12, theme = "light", className = "" }) => {
    const num = String(n).padStart(2, "0");
    const tot = String(total).padStart(2, "0");
    const dark = theme === "dark";
    return (
        <div
            aria-hidden="true"
            className={`absolute top-6 right-6 md:top-10 md:right-10 flex items-center gap-2 font-display font-bold tracking-tight ${
                dark ? "text-white/50" : "text-slate-400"
            } ${className}`}
        >
            <span className="text-lg md:text-xl tnum">{num}</span>
            <span className={`h-px w-6 ${dark ? "bg-white/20" : "bg-slate-300"}`} />
            <span className="text-[10px] md:text-xs uppercase tracking-[0.28em]">
                {tot}
            </span>
        </div>
    );
};
